<template>
  <div v-if="isAdmin"
    class="is-border-left is-border-right is-border-bottom has-bg-white">
    <div class="columns is-vcentered is-gapless is-border-bottom has-bg-light">
      <div class="column">
        <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom columns">
           <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
              @click="changeTab('create')" :class="{'is-active': tab === 'create'}">
              <span class="has-text-weight-normal">Création mandat programme</span>
          </a>
          <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
              @click="changeTab('access')" :class="{'is-active': tab === 'access'}">
              <span class="has-text-weight-normal" v-if="accesses && accesses.length">
                {{accesses.length}} Mandat<span v-if="accesses.length > 1">s</span> programme ouvert<span v-if="accesses.length > 1">s</span>
              </span>
              <span class="has-text-weight-normal" v-else>Mandat programme ouvert</span>
          </a>
          <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
              v-if="program.status !== 'private' && isDistributeurMode"
              @click="changeTab('promoteurAccesses')" :class="{'is-active': tab === 'promoteurAccesses'}">
              <span class="has-text-weight-normal" v-if="promoteurAccesses && promoteurAccesses.length">
                {{promoteurAccesses.length}} Mandat<span v-if="promoteurAccesses.length > 1">s</span> promoteur ouvert<span v-if="promoteurAccesses.length > 1">s</span>
              </span>
              <span class="has-text-weight-normal" v-else>Mandat promoteur ouvert</span>
          </a>
        </div>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <a @click="$emit('reloadAccess')" class="button is-min-width-0 is-radiusless is-light is-min-height-full">
          <span class="icon is-small is-size-6 has-text-grey"><i class="fas fa-sync"></i></span>
        </a>
      </div>
    </div>
    <div v-if="tab === 'access' && !loading">
      <div v-if="accesses && accesses.length">
        <pagination :loading="loading" @ChangePage="changePage"
                    :currentPage="page" :total-page="totalPage"></pagination>
        <table class="table is-hoverable is-striped-v is-fullwidth is-first-fixed-xsmall is-marginless-bottom is-border-bottom is-border-top">
          <thead>
            <tr class="is-size-6">
              <th></th>
              <th>Société</th>
              <th>Date de début</th>
              <th>Date de fin</th>
              <th></th>
              <th v-if="displayRemuneration">Rémunération</th>
            </tr>
          </thead>
          <program-access-item class="is-size-5 has-text-text"
                      v-for="(a, i) in accesses.slice(min, max)"
                      first-key="company"
                      :key="i"
                      :program="program"
                      :lots="lots"
                      :source="a"
                      :loading-access="loadingAccess"
                      :selected-access="selectedAccess"
                      @deleteAccess="val => $emit('deleteAccess', val)"
                      @updateAccess="submitUpdateAccess"
                      @selectedAccess="val => selectedAccess = val">
          </program-access-item>
        </table>
      </div>
      <div v-else class="column">
        <em><b>Aucun mandat programme ouvert.</b> <span v-if="displayNoAccessInfo">Seuls les vendeurs internes peuvent consulter ce programme.</span></em>
      </div>
    </div>
    <div v-if="tab === 'promoteurAccesses' && isDistributeurMode">
      <div v-if="promoteurAccesses && promoteurAccesses.length">
        <pagination :loading="loading" @ChangePage="changePage"
                      :currentPage="page" :total-page="totalPage"></pagination>
        <table class="table is-hoverable is-striped-v is-fullwidth is-first-fixed-xsmall is-marginless-bottom is-border-bottom is-border-top">
          <thead>
            <tr class="is-size-6">
              <th></th>
              <th>Société</th>
              <th v-if="displayRemuneration">Rémunération</th>
            </tr>
          </thead>
          <tbody class="is-size-5 has-text-text">
            <tr v-for="a in promoteurAccesses.slice(min, max)" :key="a.pk">
              <td class="has-text-centered">
                <span class="avatar avatar-01"><span class="has-bg-draft"><i class="fas fa-building"></i></span></span>
              </td>
              <td>
                <router-link :to="{name: 'CompanyVue', params: {id: a.company}}">{{a.company_name | truncate}}</router-link>
              </td>
              <td class="w200p is-paddingless is-marginless" v-if="displayRemuneration">
                <div class="field has-addons">
                  <div class="control">
                    <input type="number" class="input is-borderless is-medium has-text-centered"
                          placeholder="A définir" :disabled="true" :value="a.remuneration">
                  </div>
                  <div class="control">
                    <a class="button is-square is-medium is-light is-min-width-0 is-static">
                      <span class="icon is-size-5"><i class="fas fa-percentage"></i></span>
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="column">
        <em><b>Aucun mandat promoteur ouvert.</b> <span v-if="displayNoAccessInfo">Seuls les vendeurs internes peuvent consulter ce programme.</span></em>
      </div>
    </div>
    <div v-if="tab === 'create'">
      <access-form @submit="createAccess" 
                   :loading="loading" 
                   ref="accessForm" 
                   :source-lots="lots"
                   :source-program="program" 
                   :source-promoteur="program.promoteur" 
                   @canCreateAccess="val => canCreateAccess = val"></access-form>
      <div class="column is-12 is-centered is-marginless is-paddingless is-border-top columns">
        <div class="column is-4">
          <a @click="tab = 'access'" class="button is-white is-uppercase is-fullwidth">
            <span>Annuler</span>
          </a>
        </div>
        <div class="column is-4">
          <button @click="askSubmit" class="button is-success is-uppercase is-fullwidth has-text-white"
                  :disabled=" !canCreateAccess || loading" :class="{'is-loading':loading}">
            <span v-if="!loading">Enregistrer</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { sortBy, differenceBy } from 'lodash'
  import { MultiSelection } from '@/mixins'
  import { mapGetters } from 'vuex'
  import AccessForm from '@/components/access/AccessForm'
  import ProgramAccessItem from './ProgramAccessItem'

  export default {
    name: 'ProgramAccessList',
    mixins: [MultiSelection],
    components: {AccessForm, ProgramAccessItem},
    data () {
      return {
        min: 0,
        tab: 'create',
        max: 10,
        page: 1,
        perPage: 10,
        loadingAccess: false,
        selectedAccess: null,
        canCreateAccess: true
      }
    },
    props: {
      access: {
        type: Array,
        required: true
      },
      promoteurAccesses: {
        type: Array
      },
      program: {
        type: Object,
        required: true
      },
      loading: Boolean,
      lots: Array,
      setTab: String
    },
    computed: {
      ...mapGetters(['displayRemuneration', 'isAdmin', 'isDistributeurMode']),
      accesses () {
        return sortBy(this.access, x => x.company_name.toLowerCase())
      },
      totalPage () {
        if (this.tab === 'access' && 'length' in this.accesses) {
          return Math.ceil(this.accesses.length / this.perPage)
        } else if (this.isDistributeurMode && this.tab === 'promoteurAccesses' && 'length' in this.promoteurAccesses) {
          return Math.ceil(this.promoteurAccesses.length / this.perPage)
        }
      },
      displayNoAccessInfo () {
        return !['draft', 'archived'].includes(this.program.status) && (this.isDistributeurMode && (!this.promoteurAccesses || !this.promoteurAccesses.length)) && !this.accesses.length
      }
    },
    methods: {
      changeTab (tab) {
        this.tab = tab
        this.min = 0
        this.max = 10
        this.page = 1
      },
      changePage (e) {
        this.min = (e - 1) * this.perPage
        this.max = this.min + this.perPage
        this.page = e
      },
      askSubmit () {
        this.$refs.accessForm.submit()
      },
      createAccess (access) {
        if (access.newAllotments) {
          access.allotments = access.newAllotments
        }
        console.log('create access')
        this.$notify({
          type: 'is-info',
          text: 'Création des mandats en cours...'
        })
        this.simulateSubmit = false
        this.loadingAccess = true
        this.$api.accessService.post(access).then(res => {
          this.tab = 'access'
          this.loadingAccess = false
          this.selectedAccess = null
          this.$emit('reloadAccess')
        }).catch(() => {
          this.loadingAccess = false
          this.selectedAccess = null
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout du mandat.'
          })
        })
      },
      async submitUpdateAccess (access) {
        this.loadingAccess = true
        if (access.newAllotments) {
          let toCreate = differenceBy(access.newAllotments, access.allotments, x => x.lot || x.pk)
          let toDelete = differenceBy(access.allotments, access.newAllotments, x => x.lot || x.pk)
          if (toCreate && toCreate.length) await this.createAllotments(access, toCreate)
          if (toDelete && toDelete.length) await this.deleteAllotments(toDelete)
        }
        this.updateAccess(access)
      },
      async createAllotments (access, accesses) {
        let data = {
          access: access.pk,
          lots: accesses.map(x => x.pk)
        }
        try {
          await this.$api.accessService.postAllotments(data)
        } catch (e) {
          this.loadingAccess = false
          this.selectedAccess = null
        }
      },
      async deleteAllotments (accesses) {
        let data = {allotments: accesses.map(x => x.pk)}
        try {
          await this.$api.accessService.deleteAllotments(data)
        } catch (e) {
          this.loadingAccess = false
          this.selectedAccess = null
        }
      },
      updateAccess (access) {
        this.loadingAccess = true
        this.$api.accessService.patch(access.pk, access).then(r => {
          this.loadingAccess = false
          this.selectedAccess = null
          this.$notify({
            type: 'is-success',
            text: 'Le mandat à été mis à jour.'
          })
          this.$emit('updateAccess', access)
        }).catch(() => {
          this.loadingAccess = false
          this.selectedAccess = null
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du mandat.'
          })
        })
      }
    },
    created () {
      if (this.setTab !== null) this.tab = this.setTab
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/Tabs/ProgramAccessList.vue